import {createSlice} from "@reduxjs/toolkit";

export const projectSlice = createSlice({
    name: "projectList",
    initialState: {
        value: null,
    },
    reducers: {
        setProject: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const {setProject} = projectSlice.actions;

export const selectProject = (state) => state.projectList.value;

export default projectSlice.reducer;
